<template>
    <div class="dashboard">
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <login-layout v-if="!loading">
            <v-row no-gutters>
                <v-spacer></v-spacer>
                <gappt-menu class="ma-4" :user="user"></gappt-menu>
            </v-row>
            <div class="pa-6">
                <user-profile :user="user"></user-profile>
                <application-list v-if="applications" class="mt-10" :applications="applications"></application-list>
            </div>
            <v-divider class="mb-2"></v-divider>
            <div class="text-center justify-center">
                <v-btn @click="$router.replace({name: 'logout'});" outlined class="user-menu-btn">Logout</v-btn>
            </div>
        </login-layout>
    </div>
</template>

<script>
    import Vue from "vue";
    import ApplicationModel from "../models/application";
    import User from "../models/user";
    import UserProfile from "./UserProfile";
    import ApplicationList from "./ApplicationList";
    import GapptMenu from "./Menu";

    export default {
        name: "Dashboard",
        components: { GapptMenu, UserProfile, ApplicationList },
        data() {
            return {
                user: new User(),
                applications: [
                    new ApplicationModel()
                ]
            };
        },

        computed: {
            loading () {
                return this.$store.state.loading
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$sessionGuard.check(to, from, next)
        },

        mounted() {
            this.getData()
        },

        methods: {
            async getData() {
                this.$store.commit('loadingOn')

                try {
                    await Promise.all([
                        this.getUser(),
                        this.getApplications(),
                    ]);

                    this.$store.commit('loadingOff')
                } catch (e) {
                    if (this.$isDevEnviroment) {
                        console.log(e);
                    } else {
                        await this.$router.replace({ name: 'error' })
                    }
                }
            },

            async getUser() {
                let userResponse = await this.$sessionService.current();
                this.user = new User(userResponse.login)
            },

            appOrder(a, b ) {
                if ( a.dashboard_order < b.dashboard_order ){
                    return -1;
                }
                if ( a.dashboard_order > b.dashboard_order ){
                    return 1;
                }

                return 0;
            },

            async getApplications() {
                let appResponse = await this.$sessionService.applications()
                this.applications = appResponse.applications.filter(item => {
                    return item.display_on_dashboard;
                }).map(
                    item => new ApplicationModel(item)
                ).sort( this.appOrder );
            },

        }
    }
</script>

<style>
    .application_list .v-list-item__subtitle, .v-list-item__title {
        white-space: normal;
    }
</style>